export default __webpack_public_path__ + "static/media/transaction_processing-dk.d5845a1f.svg";